/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassstudentClassstudentidChannels201,
  PostApiV1ClassstudentClassstudentidChannels400,
  PostApiV1ClassstudentClassstudentidChannels401,
  PostApiV1ClassstudentClassstudentidChannels404,
  PostApiV1ClassstudentClassstudentidChannels500,
  PostApiV1ClassstudentClassstudentidChannelsMutationRequest,
  PostApiV1ClassstudentClassstudentidChannelsMutationResponse,
  PostApiV1ClassstudentClassstudentidChannelsPathParams,
} from "../../types/classStudentChannelsController/PostApiV1ClassstudentClassstudentidChannels.ts";
import { channelDetailViewModelSchema } from "../channelDetailViewModelSchema.ts";
import { upsertChannelRequestViewModelSchema } from "../upsertChannelRequestViewModelSchema.ts";

export const postApiV1ClassstudentClassstudentidChannelsPathParamsSchema =
  z.object({
    classStudentId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ClassstudentClassstudentidChannelsPathParams>;

/**
 * @description (Created) Objeto criado com sucesso.
 */
export const postApiV1ClassstudentClassstudentidChannels201Schema = z.lazy(
  () => channelDetailViewModelSchema,
) as unknown as ToZod<PostApiV1ClassstudentClassstudentidChannels201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ClassstudentClassstudentidChannels400Schema =
  z.any() as unknown as ToZod<PostApiV1ClassstudentClassstudentidChannels400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassstudentClassstudentidChannels401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassstudentClassstudentidChannels401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassstudentClassstudentidChannels404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassstudentClassstudentidChannels404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ClassstudentClassstudentidChannels500Schema =
  z.any() as unknown as ToZod<PostApiV1ClassstudentClassstudentidChannels500>;

export const postApiV1ClassstudentClassstudentidChannelsMutationRequestSchema =
  z.lazy(
    () => upsertChannelRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1ClassstudentClassstudentidChannelsMutationRequest>;

export const postApiV1ClassstudentClassstudentidChannelsMutationResponseSchema =
  z.lazy(
    () => postApiV1ClassstudentClassstudentidChannels201Schema,
  ) as unknown as ToZod<PostApiV1ClassstudentClassstudentidChannelsMutationResponse>;
